import { OrderMsnRequest, OrderMsnReason, ClaimDetailsRequest } from '@cms-max/medicare-api-sdk'

export interface OrderMSNForm {
  reason: OrderMsnReason
}

export function getOrderMsnRequest (request: ClaimDetailsRequest, segmentInd:string, { reason }: OrderMSNForm): OrderMsnRequest {
  const req: OrderMsnRequest = {
    accretionDate: request.accretionDate,
    claimNumber: request.claimNumber,
    claimToken: request.token,
    claimType: request.claimType,
    contractNumber: request.contractNumber,
    entryCode: request.entryCode,
    reason: reason
  }

  if (segmentInd) {
    req.businessSegmentIndicator = segmentInd
  }

  return req
}
